// src/lib/score.ts — ONE place for score maths and formatting.
// Use it in JudgeConsole AND every admin section so the numbers always match.
import { MARK } from '@sdg/shared'

/** Weighted score for one KPI: (mark ÷ max) × weight. */
export const kpiScore = (mark: number, weight: number) => (mark / MARK.max) * weight

/** A sheet total out of 100. */
export const sheetTotal = (kpis: { mark: number | null; weight: number }[]) =>
  kpis.reduce((s, k) => (k.mark == null ? s : s + kpiScore(k.mark, k.weight)), 0)

/** Any single judge's sheet total: always 1 decimal (same as the judge screen). */
export const fmtScore = (n: number | null | undefined) => (n == null ? '—' : n.toFixed(1))

/** An average across judges (final standing): always 2 decimals. */
export const fmtAvg = (n: number | null | undefined) => (n == null ? '—' : n.toFixed(2))

/** Colour band for a /100 score. */
export function scoreTone(n: number) {
  if (n >= 80) return 'bg-emerald-500 text-white'
  if (n >= 65) return 'bg-emerald-400 text-white'
  if (n >= 50) return 'bg-amber-400 text-white'
  return 'bg-orange-500 text-white'
}
